window.SHGlobals = window.SHGlobals || {};
window.shTestInfo = {
    isRunningTest: false
};

// non-ES6 requires so they don't get hoisted above window variable definitions and break all the things
const Arg = require('arg');
const SHGlobals = require('sh-globals');
const APIUtils = require('@spothero/utils/api').default;
const APIRegistry = require('@spothero/utils/api').APIRegistry;
const WidgetCommon = require('./widget-common').default;

window.SHWidget = {
    init() {
        SHGlobals.init();
        APIUtils.init({
            baseUrl: SHGlobals.API_PATH
        });

        // We need an absolute url for retry functionality
        const port = (window.location.port) ? `:${window.location.port}` : '';
        const prefix = `${window.location.protocol}//${window.location.hostname}${port}`;
        const searchAPIUtils = APIRegistry.create(
            {
                name: 'ratesSearch',
                config: {
                    baseUrl: `${prefix}${SHGlobals.API_PATH}`
                }
            }
        );
        searchAPIUtils.addRetry({
            retries: 10
        });

        WidgetCommon.loadConfig(config => {
            WidgetCommon.setup({
                ...Arg.query(),
                container: document.getElementById('SH-Widget-container'),
                cloudinaryCloudName: config.cloudinary_cloud_name,
                sentryKey: config.sentry_api_public_key,
                siteUrl: config.site_url_secure,
                isSegmentEnabled: config.segment_frontend_enabled,
                segmentToken: config.consumer_sales_funnel_segment_token,
                stripeKey: config.spothero_stripe_public_key,
                staticFilesDomain: config.staticfiles_domain,
                uaTrackingId: config.ua_tracking_id,
                isDeployed: config.is_deployed,
                isProduction: config.is_production,
                cloudfrontViewerCountryCode: config.cloudfront_viewer_country_code
            });
        });
    }
};



// WEBPACK FOOTER //
// ./widget/src/js/iframe.js